import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsPermissionsRoute: InvariantJiraRoute = {
	name: 'plan-settings-permissions',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions',
};
